module.exports = __webpack_public_path__ + "static/media/aragon39.865901e8.jpg";